export type ApiConsultantDetails = {
  id?: number | null;
  first_name?: string | null;
};

export function formatConsultantName(
  details?: ApiConsultantDetails | null
): string | undefined {
  const name = details?.first_name?.trim();
  if (!name || name === "-") {
    return undefined;
  }
  return name;
}
